__webpack_require__.p = "https://exodsms-qas.sms-group.com/";